import styled from 'styled-components'

export const SearchInput = styled.input`
  height: 34px;
`
